import { render, staticRenderFns } from "./home.vue?vue&type=template&id=8f17b942&scoped=true"
import script from "./home.vue?vue&type=script&lang=js"
export * from "./home.vue?vue&type=script&lang=js"
import style0 from "./home.vue?vue&type=style&index=0&id=8f17b942&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f17b942",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/home.vue
// module id = wUZA
// module chunks = 0